import React from 'react';
import { SortableContainer } from 'react-sortable-hoc';
import styled from 'styled-components';

import { State } from 'src/state/ducks';
import BakedBreadTagForm from 'src/components/organisms/form/BakedBreadTagForm';

type Props = {
  bakedBreadTags: {
    id: string;
    name: string;
    order: number;
    isFeatured: boolean;
    isDisabled: boolean;
  }[];
  onChangeName: (order: number, name: string) => void;
  onChangeRadio: (key: 'isFeatured' | 'isDisabled', order: number, bool: boolean) => void;
  onDelete: (order: number) => void;
  errors: State['bakedBreadTag']['validationErrors'];
};

const BakedBreadTagList = SortableContainer((props: Props) => {
  const { bakedBreadTags, onChangeName, onChangeRadio, onDelete, errors } = props;

  return (
    <Container>
      {bakedBreadTags.map(({ id, name, order, isFeatured, isDisabled }) => (
        <BakedBreadTagForm
          key={`BakedBreadTagForm|${id}|${order}`}
          index={order}
          id={id}
          name={name}
          order={order}
          isFeatured={isFeatured}
          isDisabled={isDisabled}
          onChangeName={onChangeName}
          onChangeRadio={onChangeRadio}
          onDelete={onDelete}
          errors={errors}
        />
      ))}
    </Container>
  );
});

const Container = styled.div`
  > * {
    margin-bottom: 16px;
    &:not(:first-child) {
      margin-bottom: 12px;
    }
  }
`;

export default BakedBreadTagList;
